import styled from 'styled-components'
import { device } from 'src/theme/theme'

export const LogoBackground = styled.section`
  background-image: url('https://res.cloudinary.com/cordasemusica/image/upload/f_webp/v1678224794/fundo-professores_btikhn.png');
  background-attachment: fixed;
  background-position: 50% 100%;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    padding-bottom: ${p => p.theme.spacing.large};
  }

  @media ${device.tablet} {
    background-position: 50% 10%;
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: 'social_media logo group_button';
  }

  .nav {
    display: none;
    @media ${device.tablet} {
      display: block;
      grid-area: social_media;
    }
  }

  .group-buttons {
    grid-area: group_button;
    display: flex;
    justify-content: center;
    align-items: center;

    @media ${device.tablet} {
      justify-content: flex-end;
    }

    a + a {
      margin-left: 0.5rem;
    }

    a {
      div {
        ${({ theme }) => ({ ...theme.typography.primary.semiBold })};
        span {
          ${({ theme }) => ({ ...theme.size.xs })};
        }
      }

      :hover {
        filter: brightness(90%);
      }
    }
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: logo;
`

export const Logo = styled.img`
  margin-bottom: 1rem;
  max-width: 190px;
`

export const NovidadesWrapper = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.5rem 1rem 1rem;
`

export const NovidadesContent = styled.div`
  width: 100%;
  max-width: 460px;
  text-align: center;
`

export const NovidadesTitle = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  color: #d84315;
  ${({ theme }) => ({ ...theme.typography.primary.bold })};
`

export const NovidadesTitleIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`

export const NovidadesActions = styled.div`
  margin-top: 0.55rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.65rem;

  @media ${device.tablet} {
    grid-template-columns: 1fr 1fr;
  }
`

export const NovidadeLink = styled.a<{ $variant: 'blue' | 'green' }>`
  border-radius: 10px;
  padding: 0.55rem 0.8rem;
  color: #fff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: filter 0.2s ease, transform 0.2s ease;
  ${({ theme }) => ({ ...theme.typography.primary.semiBold })};
  background: ${({ $variant }) =>
    $variant === 'blue' ? 'linear-gradient(135deg, #1e88e5, #1565c0)' : 'linear-gradient(135deg, #43a047, #2e7d32)'};

  &:hover {
    filter: brightness(95%);
    transform: translateY(-1px);
  }
`

export const NovidadeIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`
